import axios from "axios";
import API_VERSION from "../data/api-version";

const ShopifyGetCustomer = async (token) => {
  try {
    const response = await axios({
      url: `https://${process.env.REACT_APP_SHOP_URL}/api/${API_VERSION}/graphql.json`,
      method: "POST",
      headers: {
        "X-Shopify-Storefront-Access-Token": process.env.REACT_APP_SHOP_ACCESS_TOKEN,
      },
      data: {
        query: `{
          customer(customerAccessToken: "${token}") {
            id
            email
            points: metafield(key:"patch_points", namespace:"integration") {
              value
            }
            savedDesigns: metafield(key:"customizer_designs", namespace:"integration") {
              value
            }
          }
        }`,
      },
    });
    if (response.data.data.customer) {
      const { customer } = response.data.data;
      // work with localStorage because of wrong data from shopify
      // if you save really often. It appeared approximately on 04 Apr 2023
      const savedDesigns = localStorage.getItem(customer.id);
      const points = customer.points ? parseInt(customer.points.value) : 0;

      return savedDesigns
        ? {
            ...customer,
            points,
            savedDesigns: JSON.parse(savedDesigns),
          }
        : {
            ...customer,
            points,
            savedDesigns: customer.savedDesigns
              ? JSON.parse(decodeURIComponent(customer.savedDesigns.value))
              : {},
          };
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};

export default ShopifyGetCustomer;
